// ---------------- Hook to call the api endpoint for the tickers -------------------
// ----------------------------------------------------------------------------------
// import the services and functions
import { useState, useEffect } from 'react';
import { getNewsSentiment } from '../services/api';

// hook to fetch news sentiment data from the backend API
export const useNewsSentiment = (articles) => {

  // create the state variables for sentiments and loading
  const [sentiments, setSentiments] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => { // fetch news sentiment data from the backend API when the articles change
    
    if (!articles || articles.length === 0) { // if no articles set them to empty
      setSentiments([]);
      return;
    }

    let cancelled = false;
    setLoading(true); // start loading

    getNewsSentiment({ pageSize: articles.length }) // call the getNewsSentiment function from the api service with the pageSize parameter
      .then((response) => {
        if (cancelled) return;

        setSentiments(
          response.sentiment.map((s) => // map the sentiment values to positive, negative or neutral
            s === 1 ? 'positive' : s === -1 ? 'negative' : 'neutral'
          )
        );
      })
      .catch(() => { if (!cancelled) setSentiments([]); })
      .finally(() => { if (!cancelled) setLoading(false); });

    return () => { cancelled = true; };
  }, [articles]);

  return { sentiments, loading };
};
